import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../../../components/common/utils/handleError.component';
import { PolizaEntity } from '../../entities/polizas_cliente_entity';
import { VamTitularEntity, DependientesVam } from '../../../vam/titulares/entities/vam_titulares_entity';
import { SolicitudInclusionService } from './solicitud-inclusion.service';
import { ExclusionEntity, PlanVam, ExclusionVam, Exclusiones } from '../../entities/vam_entities';
import { MovimientosVamService } from '../movimientos/movimientosVam.service';
import { SessionStorageService } from "ngx-webstorage";
import { SolicitudExclusionService } from './solicitud-exclusion.service';
import { UtilService } from '../../../../components/common/utils/util.service';
import { ClienteLogin } from '../../../login/cliente_login';
import { timeInterval } from 'rxjs/operator/timeInterval';
import { fail } from 'assert';
import { checkNoChangesNode } from '@angular/core/src/view/view';


const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
    selector: 'solicitudExclusion',
    templateUrl: 'solicitud-exclusion.template.html'
})

export class SolicitudExclusionComponent implements OnChanges {
    @Input() polizaContratadaVam: PolizaEntity;
    @Input() planVam: number;
    @Input() planVamNombre: string;
    usuario: ClienteLogin;
    listaExclusiones: ExclusionEntity[];
    listaTitulares: VamTitularEntity[];
    showLoader: string;
    nombresPlanes: string[];
    planesVam: PlanVam[];
    planSeleccionado: number;
    filterQuery: string;
    filterQuery2: string;
 

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError,
        private exclusionesService: SolicitudExclusionService,
        public utilsService: UtilService,
        public sesionStorageService: SessionStorageService,
        public movimientosService: MovimientosVamService
    ) { }

    ngOnChanges() {
        
        this.polizaContratadaVam = jQuery.parseJSON(this.sesionStorageService.retrieve("polizaSelecionada"));
        this.consultarTodo();
        
    }

    excluirDependiente(titular: VamTitularEntity, dependiente: DependientesVam) {
        let bandera = false;
        this.listaExclusiones.forEach(a => {
            if (a.CodigoBeneficiario == dependiente.CodigoDependiente && a.BanderaDependiente == true) {
                bandera = true;
            }
        });
        if (!bandera) {
            let dependienteExcluido = new ExclusionEntity();
            dependienteExcluido.BanderaDependiente = true;
            dependienteExcluido.CodigoBeneficiario = dependiente.CodigoDependiente;
            dependienteExcluido.NombresApellidos = dependiente.PrimerNombre + " " + dependiente.SegundoNombre + " " + dependiente.ApellidoPaterno + " " + dependiente.ApellidoPaterno;
            dependienteExcluido.Identificacion = titular.Cedula;
            dependienteExcluido.CodigoTitular = titular.CodigoTitular;
            dependienteExcluido.CodigoUsuario = this.usuario.CodigoUsuario;
            this.listaExclusiones.push(dependienteExcluido);
            dependiente.BanderaExclusion = true;
        } else {
            this.listaExclusiones = this.listaExclusiones.filter(a => a.CodigoBeneficiario != dependiente.CodigoDependiente && a.CodigoTitular != dependiente.CodigoTitular);
            dependiente.BanderaExclusion = false;
        }
    }
    excluirTitular(titular: VamTitularEntity) {
        let bandera = false;
        let bandera2 = false;
        this.listaExclusiones.forEach(a => {
            if (a.CodigoBeneficiario == titular.CodigoTitular && a.BanderaDependiente == false && a.CodigoTitular == titular.CodigoTitular) {
                bandera = true;
            }
        });
        if (!bandera) {
            let titularExcluido = new ExclusionEntity();
            titularExcluido.BanderaDependiente = false;
            titularExcluido.CodigoBeneficiario = titular.CodigoTitular;
            titularExcluido.CodigoUsuario = this.usuario.CodigoUsuario;
            titularExcluido.NombresApellidos = titular.PrimerNombre + " " + titular.SegundoNombre + " " + titular.ApellidoPaterno + " " + titular.ApellidoMaterno;
            titularExcluido.Identificacion = titular.Cedula;
            titularExcluido.CodigoTitular = titular.CodigoTitular;
            this.listaExclusiones.push(titularExcluido);
            titular.BanderaExclusion = true;
            if (titular.Dependientes != null && titular.Dependientes != undefined) {
                titular.Dependientes.forEach(a => {
                    this.listaExclusiones.forEach(b => {
                        if (b.CodigoBeneficiario == a.CodigoDependiente && b.BanderaDependiente == true) {
                            bandera2 = true;
                        }
                    });
                    if (!bandera2) {
                        let dependienteExcluido = new ExclusionEntity();
                        dependienteExcluido.BanderaDependiente = true;
                        dependienteExcluido.CodigoBeneficiario = a.CodigoDependiente;
                        dependienteExcluido.NombresApellidos = a.PrimerNombre + " " + a.SegundoNombre + " " + a.ApellidoPaterno + " " + a.ApellidoPaterno;
                        dependienteExcluido.Identificacion = titular.Cedula;
                        dependienteExcluido.CodigoTitular = titular.CodigoTitular;
                        dependienteExcluido.CodigoUsuario = this.usuario.CodigoUsuario;
                        this.listaExclusiones.push(dependienteExcluido);
                        a.BanderaExclusion = true;
                    }
                });
            }
        } else {
            this.listaExclusiones = this.listaExclusiones.filter(a => a.CodigoBeneficiario != titular.CodigoTitular && a.CodigoTitular != titular.CodigoTitular);
            titular.BanderaExclusion = false;
            if (titular.Dependientes != null && titular.Dependientes != undefined) {
                titular.Dependientes.forEach(a => {
                    this.listaExclusiones = this.listaExclusiones.filter(b => b.CodigoBeneficiario != a.CodigoDependiente && b.CodigoTitular != a.CodigoTitular);
                    a.BanderaExclusion = false;
                });
            }
        }
    }

    enviarExclusion() {
        swal({
            title: 'Está seguro de realizar la(s) exclusión(es) solicitada(s)?',
            text: "Usted no podrá revertir este cambio!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#A14950',
            cancelButtonColor: '#c1c1c1',
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        }).then((function () {
            let exclusionVam = new ExclusionVam();
            exclusionVam.CodigoCiudad = this.polizaContratadaVam.CodigoCiudad;
            exclusionVam.CodigoCliente = this.polizaContratadaVam.CodigoCliente;
            exclusionVam.NombrePlan = this.planVamNombre;
            exclusionVam.Poliza = this.polizaContratadaVam;
            exclusionVam.ListaExclusiones = this.listaExclusiones;
            exclusionVam.CodigoPlan = this.planVam;
            this.exclusionesService.enviarSolicitudExclusion(exclusionVam).subscribe(
                result => {
                    swal({
                        title: 'Solicitud enviada exitosamente',
                        text: 'La solicitud de exclusión se realizó correctamente',
                        type: 'success'
                    }).then((function () {
                        this.consultarTodo();
                    }).bind(this));
                },
                error => {
                    this.handleError.redirectUrl(error);
                }
            );
        }).bind(this))
    }
    consultarTodo() {
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        this.showLoader = "sk-loading";
        this.listaExclusiones = new Array<ExclusionEntity>();
        this.exclusionesService.consultarTitularesDependientes(this.polizaContratadaVam).subscribe(
            result => {
                this.listaTitulares = result;
                this.listaTitulares.forEach(a => {
                    a.BanderaYaExcluido = false;
                });
                let excluidos = new Exclusiones();
                excluidos.CodigoCliente = this.polizaContratadaVam.CodigoCliente;
                excluidos.CodigoPlan = this.planVam;
                this.exclusionesService.consultarExclusiones(excluidos).subscribe(
                    result => {
                        if (this.listaTitulares != null && this.listaTitulares != undefined && this.listaTitulares.length > 0 && result != null && result != undefined && result.length > 0) {
                            this.listaTitulares.forEach(a => {
                                result.forEach(b => {
                                    if (b.TipoBeneficiario == 1) {
                                        if (b.CodigoBeneficiario == a.CodigoTitular) {
                                            a.BanderaYaExcluido = true;
                                        }
                                    }
                                });
                            });
                            this.listaTitulares.forEach(a => {
                                if (a.Dependientes != null && a.Dependientes != undefined && a.Dependientes.length > 0) {
                                    a.Dependientes.forEach(b => {
                                        result.forEach(c => {
                                            if (c.TipoBeneficiario == 2) {
                                                if (c.CodigoBeneficiario == b.CodigoDependiente) {
                                                    b.BanderaYaExcluido = true;
                                                }
                                            }
                                        });
                                    });
                                }
                            });
                        }
                        this.showLoader = "";
                    },
                    error => {
                        this.handleError.redirectUrl(error);
                    }
                );
            },
            error => {
                this.handleError.redirectUrl(error);
            }
        );
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/solicitudes/solicitud-exclusion.component.ts